export var getDefaultStyleSheet = _ref => {
  var {
    designContext,
    size
  } = _ref;
  var sizePixels = size === 'small' ? 30 : size === 'medium' ? 40 : size === 'large' ? 70 : 50;
  var borderRadius = designContext.get('klarna-avatar/corner-radius').value();
  return {
    logoStyle: {
      alignItems: 'center',
      backgroundColor: '#FFB3C7',
      borderRadius,
      height: sizePixels,
      justifyContent: 'center',
      width: sizePixels
    },
    logoLetterStyle: {
      left: size === 'small' ? 1 : size === 'medium' ? 2 : size === 'large' ? 3 : 2,
      color: '#17120F'
    }
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map